import { useEffect } from 'react';
import { useLazyListAsyncJobsQuery } from '@app/features/asyncJobs/asyncJobsApiSlice';
import { setAsyncJobs } from '@app/features/asyncJobs/asyncJobsSlice';
import { useAppDispatch } from '@app/hooks';

export const useRehydrateAsyncJobs = () => {
  const dispatch = useAppDispatch();
  const [listJobs] = useLazyListAsyncJobsQuery();

  useEffect(() => {
    const rehydrate = async () => {
      try {
        const result = await listJobs();
        if (result.data) {
          dispatch(setAsyncJobs(result.data));
        }
      } catch (error) {
        console.error('Failed to re-hydrate async jobs:', error);
      }
    };

    rehydrate();
  }, [dispatch, listJobs]);
};

export default useRehydrateAsyncJobs;
